import * as ActionTypes from 'state/actions/types'

export const usersChangeField = (field, value) => {
  return {
    type: ActionTypes.USERS_CHANGE_FIELD,
    field,
    value
  }
}

export const usersChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.USERS_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const usersMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.USERS_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
